import React, { useState, useEffect } from 'react';
import { DashboardContainer } from 'components';
import Body from './Body';
import API from 'services/api';
import { toast } from 'react-toastify';

const Index = () => {
  const [tableData, setTableData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [searchInput, setSearchInput] = useState('');

  useEffect(() => {
    if (searchInput == '') {
      setTableData(originalData);
    } else {
      const filteredResults = originalData.filter((data) =>
        Object.values(data).join(', ').toLowerCase().includes(searchInput.toLowerCase())
      );
      setTableData(filteredResults);
    }
  }, [searchInput]);

  useEffect(() => {
    toast.promise(init(), {
      pending: 'Report is loading',
      success: 'Report generated successfully',
      error: 'Something went wrong.'
    });
  }, []);

  const init = async () => {
    await API.getCardUpdateReport().then((res) => {
      if (res) {
        setTableData(res);
        setOriginalData(res);
      }
    });
  };

  return (
    <DashboardContainer>
      <Body _this={{ tableData, searchInput, setSearchInput }} />
    </DashboardContainer>
  );
};

export default Index;
